module.exports = __webpack_public_path__ + "static/media/b16@2x.f0c80896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/floorplates/b16@2x.png
// module id = 224
// module chunks = 0